// -----------------------------------------------------------------------------
export function calendar_onload({ getters, rootGetters, commit }) {
  console.log("calendar_onload - TODO")
}

/* -------------------------- Calendar View Settings ------------------------ */

export function calendar_command({ dispatch }, { command }) {
  switch ( command ) {
    case 'prev': break;
    case 'next': break;
    case 'today': break;
  }

  dispatch('calendar_set_view_range', {
    from: null, // TODO
    to: null // TODO
  });
}

export function calendar_set_view_range({ commit }, {
  from,   /* eMoment */
  to,     /* eMoment (optional) */
  horizon /* Int (optional) */
}) {

  // TODO: Validate isEnhancedMoment

  if ( horizon ) {
    to = from.clone().add(horizon, 'days');
  } else {
    horizon = to.diff(from, 'days');
  }

  console.log("[calendar] setting view range to:",
    from.format(), "-", to.format(),
    "( horizon =", horizon,")");

  commit('SET_CALENDAR_VIEW_RANGE',{
    from_date: from.toStore(),
    to_date:   to.toStore(),
    horizon:   horizon
  })

  commit('DEHYDRATE_VIEW_SETTINGS');
}

export function calendar_set_view({ commit }, view) {
  // TODO: Merge with calendar_set_view_range?
  if ( !['agenda', 'agendaWeek', 'list'].includes( view ) ) {
    throw new Error('calendar_set_view: Unsupported view', view)
  }
  commit('SET_CALENDAR_VIEW', view);
  commit('DEHYDRATE_VIEW_SETTINGS');
}

export function calendar_set_zoom({ commit }, zoom) {
  // TODO: Validate Zoom -> must be sting with format 00:00:00
  commit('SET_CALENDAR_ZOOM', zoom);
  commit('DEHYDRATE_VIEW_SETTINGS');
}

export function calendar_set_visible_time({ commit }, data) {
  /* Input either array [0, 24] or object { min_time: 0, max_time: 24 } */

  if ( Array.isArray( data ) ) {
    data = {
      min_time: data[0],
      max_time: data[1]
    }
  }
  commit('SET_CALENDAR_VISIBLE_TIME', {
    min_time: data.min_time,
    max_time: data.max_time
  });
  commit('DEHYDRATE_VIEW_SETTINGS');
}

export function calendar_toggle_source_view({ commit }, key ) {
  const VALID_KEYS = [ 'optimizer', 'user', 'tsc', '_stacking' ];
  if ( !VALID_KEYS.includes(key) ) {
    throw new Error("Invalid key", key)
  }
  console.log("[calendar] calendar_toggle_source_view", key);
  commit('TOGGLE_CALENDAR_SOURCE_VIEW', key)
  commit('DEHYDRATE_VIEW_SETTINGS');
}

export function calendar_show_source_view({ commit }, key ) {
  const VALID_KEYS = [ 'optimizer', 'user', 'tsc', '_stacking' ];
  if ( !VALID_KEYS.includes(key) ) {
    throw new Error("Invalid key", key)
  }
  commit('SHOW_CALENDAR_SOURCE_VIEW', key)
  commit('DEHYDRATE_VIEW_SETTINGS');
}

export function calendar_hide_source_view({ commit }, key ) {
  const VALID_KEYS = [ 'optimizer', 'user', 'tsc', '_stacking' ];
  if ( !VALID_KEYS.includes(key) ) {
    throw new Error("Invalid key", key)
  }
  commit('HIDE_CALENDAR_SOURCE_VIEW', key)
  commit('DEHYDRATE_VIEW_SETTINGS');
}

export function calendar_toggle_now_indicator({ commit }) {
  commit('TOOGLE_CALENDAR_NOW_INDICATOR');
  commit('DEHYDRATE_VIEW_SETTINGS');
}
